__turbopack_context__.v({
  "card": "TripContact-module__8Dhh3a__card",
  "heading": "TripContact-module__8Dhh3a__heading",
  "intro": "TripContact-module__8Dhh3a__intro",
  "link": "TripContact-module__8Dhh3a__link",
  "linkFilled": "TripContact-module__8Dhh3a__linkFilled",
  "linkGhost": "TripContact-module__8Dhh3a__linkGhost",
});
